import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { Content, Message } from 'react-bulma-components';

import { errorTraceID } from '../../../services/utility';

import './snackbar.scss';

const CustomSnackbarV2 = ({ messageList, type = 'danger', styles }) => {
    const dom = useMemo(() => {
        let list;
        if (typeof messageList === 'string' && messageList) {
            list = [
                {
                    messages: [messageList]
                }
            ];
        } else if (
            Array.isArray(messageList) &&
            messageList.length &&
            messageList.filter((message) => message).every((message) => typeof message === 'string')
        ) {
            list = [
                {
                    messages: messageList
                }
            ];
        } else if (Array.isArray(messageList) && messageList.length) {
            list = messageList;
        } else {
            return null;
        }

        return list
            .filter((error) => error)
            .map((error, index) => {
                let messages;
                if (Array.isArray(error.messages)) {
                    messages = error.messages
                        .filter((message) => message)
                        .map((message, index) => {
                            if (typeof message === 'string') {
                                const sanitizedMessage = DOMPurify.sanitize(message);
                                return <li key={index} dangerouslySetInnerHTML={{ __html: sanitizedMessage }} />;
                            }

                            return <li key={index}>{message}</li>;
                        });
                } else if (typeof error.messages === 'string') {
                    const sanitizedMessage = DOMPurify.sanitize(error.messages);
                    messages = <li>{sanitizedMessage}</li>;
                }

                const traceMessage = errorTraceID(error.error);

                if (!messages && !traceMessage) {
                    return null;
                }

                return (
                    <Message color={type} key={index}>
                        <Message.Body>
                            <Content>
                                <ul>
                                    <li>
                                        {error.title && <li>{error.title}</li>}
                                        {messages}
                                        {traceMessage ? <li>{traceMessage}</li> : undefined}
                                    </li>
                                </ul>
                            </Content>
                        </Message.Body>
                    </Message>
                );
            });
    }, [messageList, type]);

    if (!dom) {
        return null;
    }

    return (
        <div className='snackbar__container' style={styles}>
            {dom}
        </div>
    );
};

export default CustomSnackbarV2;

CustomSnackbarV2.propTypes = {
    messageList: PropTypes.array,
    type: PropTypes.string,
    styles: PropTypes.object
};
